import { ClassProvider } from '@angular/core';

import { Types } from '../../../domain/types.domain';
import { ValidateAccountConfirmationService } from '../../../domain/auth/services/validate-account-confirmation.service';

export class ValidateAccountConfirmationServiceInstruction implements ClassProvider {
  provide = Types.ValidateAccountConfirmationService;
  deps = [Types.Settings, Types.AuthRepository];
  useClass = ValidateAccountConfirmationService;
}
